// linked: '@:global.terms 使用内部连结范例 @:global.policy'
// hello: '{msg} world'  => {{ $t('message.hello', { msg: 'hello' })
// hello: '{0} world' => {{ $t('message.hello', ['hello']) }}
// car: 'car | cars' => {{ $tc('car', 1) }}, {{ $tc('car', 2) }}

export default {
  global: {
    next: "下一步",
    prev: "上一步",
    selectAll: "全选",
    action: "动作",
    view: "查看",
    day: "天",
    hour: "时",
    hourFull: "小时",
    minute: "分",
    second: "秒",
    quickView: "快速查看",
    viewAll: "查看全部",
    ok: "确定",
    cancel: "取消",
    close: "关闭",
    submit: "送出",
    setting: "设定",
    default: "预设",
    choose: "选择",
    type: "类型",
    areYouSure: "确定执行?",
    confirmDelete: "确定删除",
    confirmCancel: "确定取消",
    empty: "查无资料",
    update: "更新",
    sortBy: "排序方式",
    use: "使用",
    remove: "移除",
    delete: "删除",
  },
  paging: {
    prevPage: "上一页",
    nextPage: "下一页",
    totalCount: "共 {0} 笔",
  },
  errors: {
    serverErr: "系统发生异常, 请稍后再试!",
    inputError: "请检查资料是否填写完整",
    requiredLogin: "请先登入会员",
    submitOrderError: "建立订单失败! 系统繁忙或网路异常，请重试",
    pleaseInput: "请输入 {0}",
    pleaseSelect: "请选择 {0}",
    pleaseUpload: "请上传 {0}",
    formatError: "{0} 格式错误",
    digits: "请输入整数",
  },
  carts: {
    continueShopping: "去逛逛",
    empty: "购物车还没有东西! 快点加入商品吧!",
    totalItemAndTotal: "({0} 项商品) 折扣后总金额",
    buyerInfo: "填写订购人资讯",
    required: "必填",
    optional: "选填",
    currentlySelected: "您目前选了",
    items: "件商品",
    goToEvent: "前往活动",
    modelInvalid: "型号失效",
    ProductOff: "商品下架",
    ProductRemaining: "剩下 {0} 个商品",
    shippingMethod: "配送方式",
    invalidItem: "商品【{0}】已失效，请取消勾选",
    removedItem: "商品【{0}】已下架，请取消勾选",
    inventoryItem: "商品【{0}】库存不足，请取消勾选",
    abnormalItem: "商品【{0}】资料异常，请取消勾选",
    sameAsBuyer: "与宅配地址相同",
    shoppingCart: "购物车",
    gift: "赠品",
    addOn: "加购品",
    differentBuyer: "收件人与订购人不同",
    addToCart: "加入购物车",
    soldOut: "已售完",
    buyNow: "直接買",
    giveAwayDone: "赠送完毕",
    useDiscountCode: "使用折扣码",
    emptyDiscountCode: "无可用折扣码",
  },
  orders: {
    title: "我的订单",
    cycleOrders: "循环购订单",
    memo: "备注",
    assortDiscount: "商品折扣",
    promDiscount: "活动折扣",
    enable_coin_discount: "红利折抵",
    insuranceFees: "售后保障",
    deliveryFeesDiscount: "运费折扣",
    deliveryFees: "运费",
    productDetails: "商品",
    qty: "数量",
    price: "金额",
    subtotal: "商品总额",
    total: "总计",
    buyerName: "订购人姓名",
    buyerPhone: "订购人手机",
    toName: "收件人姓名",
    toPhone: "收件人手机",
    toAddress: "收件人地址",
    mart: "门市",
    paymentMethod: "付款方式",
    shippingMethod: "配送方式",
    addressHint: "※ 实际运费会依配送地区重新计价。",
    recipientInfo: "填写收件人资讯",
    shippingAddress: "宅配地址",
    shop711: "7-11门市",
    shopFami: "全家门市",
    shopHilife: "莱尔富门市",
    shopOkmart: "OK门市",
    discount: "折扣金额",
    otherFees: "其他手续费",
    paymentFees: "金流手续费",
    id: "订单编号",
    createAt: "订单日期",
    orderNo: "订单编号",
    createDate: "订单日期",
    status: "订单状态",
    orderTotal: "订单金额",
    empty: "没有订单资料",
    mStatus: {
      pending_payment: "待付款",
      processing: "进行中",
      already_delivery: "已出货",
      pending_refund: "待退款",
      done: "已完成",
      abnormal_done: "异常结束",
      expired: "已到期",
      active: "启用中",
    },
    trackingNo: "讬运单号",
    shippingLogs: "出货纪录",
    shippingDetails: "出货内容",
    refundDetails: "退款内容",
    refundMethod: "退款方式",
    refundAccount: "退款帐户",
    refundQty: "退款数量",
    refundAmount: "退款金额",
    refundStatus: {
      pending: "等待退款",
      processing: "退款申请中",
      done: "退款完成",
      canceled: "已取消",
    },
    cancelOrder: "取消此笔订单",
    CancellationByCustomer: "客户自行取消",
    canceled: "订单已取消",
  },
  invoices: {
    title: "发票资料",
    type: "发票类型",
    personal: "二联式纸本发票",
    company: "三联式纸本发票",
    donation: "捐赠发票",
    eturnkey: "电子发票",
    member: "会员载具",
    mobile: "手机载具",
    mobileCode: "手机载具条码",
    moica: "自然人凭证",
    moicaCode: "自然人凭证条码",
    requestPaper: "索取纸本",
    uniformNumbers: "统一编号",
    companyName: "企业抬头",
    carrierCode: "载具条码",
    address: "发票寄送地址",
  },
  products: {
    temperature0: "常温",
    temperature1: "冷藏",
    temperature2: "冷冻",
    priceLowToHigh: "价格低到高",
    priceHighToLow: "价格高到低",
    empty: "没有更多商品了",
  },
  promotions: {
    ended: "已结束",
    closed: "已结团",
    groupBuy: "本次团购",
    countdownClose: "结团倒数",
    countdownCloseSingle: "倒数",
    comingSoonSingle: "再等",
    conditionAmount: "满额",
    conditionQty: "满件",
    discountTypeAmount: "折扣金额",
    discountTypePercentage: "%折扣",
    less: "小于",
    newArrival: "最新上架",
    expireDate: "到期时间",
    bestSelling: "热销",
    empty: "没有更多促销了",
    notYetStarted: "尚未开团",
    selectSpec: "查看规格",
    freeGift: "送赠品",
    fill: "满",
    fillUnit: "件",
    gift: "送",
    discounts: "折",
    code: "折扣码",
    saveCode: "储存折扣码",
    saveCodeSuccess: "储存折扣码完成",
    now: "现在",
    past: "过去",
    memberOnly: "限定会员使用",
    lowAmount: "最低消费",
    expiryDate: "有效期限",
    timesLeft: "剩余",
    discount: "折扣",
    maxAmount: "最高",
    emptyCodes: "没有更多折扣码了",
    subtotal: "全站可用",
    categories: "指定分类",
    products: "指定商品",
  },
  coins: {
    title: "红利折抵",
    yourCoins: "红利馀额",
    maxCoins: "最高可使用 {0}",
    useCoin: "本次使用",
    useAllCoin: "全部抵用",
    useHint: "红利折抵最高至商品 0 元为止，无法折抵运费使用",
    record: "红利纪录",
    earnedCoins: "获得纪录",
    awaitingCoins: "即将获得",
    usedCoins: "使用纪录",
    subscriptionCoins: "订阅红利",
    subscriptionOfflineCoins: "下线订阅红利",
    orderCoins: "订单红利",
    orderOfflineCoins: "下线订单红利",
    kolCoins: "网红订单红利",
    bonus: "红利",
    subscriber: "订阅人",
    buyer: "购买人",
  },
  users: {
    title: "会员资料",
    name: "姓名",
    email: "信箱",
    phone: "手机",
    toAddress: "通讯地址",
    province: "县市",
    city: "行政区域",
    region: "乡镇里邻",
    road: "道路",
    address: "详细地址",
    postcode: "邮递区号",
    realName: "真实姓名",
    identityNo: "身份证字号",
    birthday: "生日",
    buyerAddress: "户籍地址",
    buyerAddressHelper: "(需与身份证同)",
    buyerAddressDesc: "需包含邻里资讯",
    tel: "联络电话",
    updateSuccess: "会员资料已更新",
  },
  accounts: {
    userInfo: "用户资讯",
    createBankAccount: "银行帐号",
    confirmInfo: "确认内容",
    identitySuccess: "帐号设定完成",
    decryptData: "个资解密",
    bankInfoAlert: "银行帐号资讯需与身份证字号一致, 否则可能会影响日后拨款权益",
    address: "常用地址",
    addAddress: "加入常用地址",
    selectAddress: "选择常用地址",
    createAddress: "新增常用地址",
    editAddress: "编辑常用地址",
    deleteAddress: "删除此笔常用地址",
    updateAddressSuccess: "常用地址已更新",
    createAddressSuccess: "常用地址已新增",
    removeAddressSuccess: "常用地址已删除",
    createRefundAccount: "新增退款帐户",
  },
  bankInfo: {
    atmTitle: "银行虚拟 ATM 帐户",
    atmAccountName: "帐户名称",
    atmAccountNo: "虚拟帐号",
    accountName: "银行户名",
    accountNo: "银行帐号",
    bank: "银行名称",
    branch: "分行名称",
    accountImg: "存折图档",
    accountImgTip: "银行存折正面图片",
    amount: "应付金额",
    expireDate: "有效期限",
  },
  subscriptions: {
    startAt: "订阅时间",
    paidAt: "付款时间",
    notPaidYet: "尚未付款",
    goToPayment: "前往付款",
    changePaymentMethod: "变更付款方式",
    changePaymentMethodSuccess: "订单付款方式已变更",
    paid: "付费订阅",
    giftRecord: "赠送纪录",
    record: "订阅纪录",
  },
}
